import {Component, NgModule, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Validators} from "@angular/forms";
import {Router} from "@angular/router";

import {TranslateModule} from "@ngx-translate/core";

import {InputTextModule} from "primeng/inputtext";
import {CheckboxModule} from 'primeng/checkbox';
import {ButtonModule} from "primeng/button";

import {AccessControlService} from "../../shared/service/access-control.service";
import {MotoAiRegistrationService} from "../../shared/service/moto-ai-registration.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  motoAiForm!: UntypedFormGroup;
  systemLanguage = navigator.language || (navigator as any).userLanguage;

  emailError = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private accessControl: AccessControlService,
    private motoAiRegistrationService: MotoAiRegistrationService
  ) {}

  ngOnInit(): void {
    this.motoAiForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      isRequirementsConfirmed: [false, Validators.requiredTrue]
    });
  }

  onSubmit() {
    this.motoAiRegistrationService.subscribeUser(this.motoAiForm.value, this.systemLanguage)
      .subscribe(
        async () => {
          this.emailError = false;
          this.accessControl.allowAccess();
          this.router.navigate(['/download']);
        },

        (responseError: HttpErrorResponse) => {
          this.emailError = responseError.status === HttpStatusCode.BadRequest;

          if (responseError.status === HttpStatusCode.Conflict) {
            this.accessControl.allowAccess();
            this.router.navigate(['/download']);
          }
        }
      );
  }

  redirectToLearnMore() {
    window.location.href = 'https://www.motorola.com/moto-ai';
  }

}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule
  ],
  declarations: [HomeComponent],
  exports: [HomeComponent]
})
export class HomeModule {
}
